fragment SupplierControlPanelCategoryProfitFragment on SupplierControlPanelCategoryProfit {
    id
    supplier_id
    category_en
    enabled
    category_mapping
    product_profit_grade
}